import { ApiError } from '../../types/apiError'

export interface ClassificacaoDeFalha {
  /** Encerra a sessão de pagamento e volta para a home. */
  encerra: boolean
  /** Consome uma das tentativas de pagamento do usuário. */
  consomeTentativa: boolean
}

/**
 * Classifica a falha de pagamento exclusivamente pelo STATUS.
 *
 * O `pagar()` da API passou a emitir um status por causa (commit "fix(payment):
 * return distinct status codes for card payment failures"), então a heurística
 * de texto que existia aqui foi removida: ela dependia de a API escrever
 * "expirada"/"limite de tentativas" na mensagem e voltaria a falhar em silêncio
 * na primeira reescrita dessas frases.
 */
export default function classifyPaymentFailure(erro: ApiError): ClassificacaoDeFalha {
  switch (erro.status) {
    case 404: // compra não encontrada
    case 409: // compra expirada, já em processamento ou no limite de tentativas
    case 429: // limite de tentativas no throttle
    case 503: // gateway indisponível
      return { encerra: true, consomeTentativa: false }

    case 0: // navegador não alcançou o middleware
    case 502: // middleware não alcançou a API — não houve recusa do gateway
      return { encerra: false, consomeTentativa: false }

    case 402: // emissor negou o cartão — retentável com outro cartão
      return { encerra: false, consomeTentativa: true }

    default:
      return { encerra: false, consomeTentativa: true }
  }
}
